import { stateful, useEffect } from '@adornis/functional-lit/stateful.js';
import { makeRouter } from '@adornis/router/client/make-router.js';
import { addPageHeaderAdditional, removePageHeaderAdditional } from '@martinus/styles/client/PageHeader.js';
import { PageTabs } from '@martinus/styles/client/PageTabs.js';
import { html } from 'lit';
import { SgQuittungenDataView } from '../../quittungen/client/sg-quittungen-data-view.js';
import { SGAdminDashboardAccounting } from './sg-admin-dashboard-accounting.js';

enum AdminDashboardAccountingTabs {
  SEPA = 'SEPA',
  QUITTUNGEN = 'Quittungen',
}

const adminAccountingSubpages = {
  root: {
    label: AdminDashboardAccountingTabs.SEPA,
    path: '/',
  },
  quittungen: {
    label: AdminDashboardAccountingTabs.QUITTUNGEN,
    path: '/quittungen',
  },
} as const;

export const adminAccountingRouter = makeRouter({
  [adminAccountingSubpages.root.label]: {
    path: '/',
    render: SGAdminDashboardAccounting,
  },
  [adminAccountingSubpages.quittungen.label]: {
    path: adminAccountingSubpages.quittungen.path,
    render: () => html` ${SgQuittungenDataView()} `,
  },
});

export const SGAdminDashboardAccountingRouterPage = stateful(() => {
  useEffect(() => {
    addPageHeaderAdditional(
      1,
      PageTabs({
        tabs: Array.from(Object.values(adminAccountingSubpages)).map(subPage => ({
          key: subPage.label,
          label: subPage.label,
        })),
        activeKey: () => adminAccountingRouter.currentRoute.value.route.name,
        onSelect: tabKey => {
          adminAccountingRouter.goTo(
            tabKey as (typeof adminAccountingSubpages)[keyof typeof adminAccountingSubpages]['label'],
          );
        },
      }),
    );
    return () => {
      removePageHeaderAdditional(1);
    };
  }, []);

  return html` ${adminAccountingRouter.outlet.value} `;
});
